import { render } from "./OdinCard.vue?vue&type=template&id=5690582a"
import script from "./OdinCard.vue?vue&type=script&lang=js"
export * from "./OdinCard.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__